<template>
	<table class="table-list" border="0" cellpadding="0" cellspacing="0">
		<thead>
			<tr>
				<th v-if="selectable">
					<input type="checkbox" v-model="checkAll" :disabled="!disabledAllRows">
				</th>
				<th is="table-column-item" v-for="column in columns" v-bind:key="column.id"
				  v-bind:column="column" v-on:on-column-sortable="columnSortable(column)">
				</th>
				<th v-if="includeDelete">
					<a v-on:click="onDeleteRows">
						<i class="icon-delete material-icons icon">delete</i>
					</a>
				</th>
				<th v-if="includeExportToExcel">
					<a v-on:click="onExportRows">
						<i class="icon-export material-icons icon">insert_drive_file</i>
					</a>
				</th>
				<th v-if="includeSearch">
					<div class="input-group__input search-input right">
						<input type="text" placeholder="Buscar" v-model="search" v-on:keyup.enter="searchRows"
						  v-on:keyup.esc="searchRows">
						<i class="material-icons icon input-group__append-icon">search</i>
					</div>
				</th>
				<th v-if="includeOptions && !includeDelete && !includeExportToExcel && !includeSearch">
					&nbsp;
				</th>
			</tr>
		</thead>
		<tbody>
			<template>
				<tr v-for="row in bodyRows"
					v-bind:key="row[keyValue]"
					draggable="true"
					droppable="true"
					@dragover.prevent
					v-on:dragenter="onDragEnter(row)"
					v-on:dragleave="onDragLeave(row)"
					v-on:drop="onDrop(row)"
					v-on:drag="onDrag(row)">
					<td v-if="selectable">
						<input type="checkbox" v-model="row.isSelected" :disabled="row[disabledProp]">
					</td>
					<slot name="rows" v-bind:row="row"></slot>
					<td v-if="includeDelete && !includeOptions">&nbsp;</td>
					<td v-if="includeExportToExcel && !includeOptions">&nbsp;</td>
					<td v-if="includeSearch && !includeOptions">&nbsp;</td>
					<td v-bind:colspan="colspan" v-if="includeOptions" class="options-column">
						<slot name="options"></slot>
						<span class="options-item" v-if="includeState">
							<span v-bind:class="`circle-state state-${row[statePropertyName]}`"></span>
						</span>
						<span class="options-item" v-if="includeImages">
							<a v-on:click.prevent="goToPhotosPage(row)" class="link-to">
								<i class="image-icon material-icons icon">collections</i>
							</a>
						</span>
						<span class="options-item" v-if="includeSwitch">
							<label class="switch" :for="`inptSwitch-${row[keyValue]}`">
								<input type="checkbox" :id="`inptSwitch-${row[keyValue]}`" v-model="row[switchValue]"
								  v-bind:true-value="1" v-bind:false-value="0" v-on:click="onChangeState(row)"
								/>
								<div class="slider round"></div>
							</label>
						</span>
						<span class="options-item" v-if="includeInfo">
							<button type="button" class="button-info" v-on:click="openDetail">
								<i class="info-icon material-icons icon">info</i>
							</button>
						</span>
						<span class="options-item" v-if="includeSettings">
							<a v-on:click.prevent="goToEditPage(row, $event)" class="link-to">
								<i class="settings-icon material-icons icon">settings</i>
							</a>
						</span>
						<span class="options-item" v-if="includeDeleteSingle">
							<button type="button" class="button-info" v-on:click="deleteRow(row)">
								<i class="info-icon material-icons icon">delete</i>
							</button>
						</span>
						<span class="options-item" v-for="btn in optionButtons" :key="btn.id">
							<button :title="btn.title" type="button" class="button-info" v-on:click="$emit('custom-button', { btn, row })">
								<i class="info-icon material-icons icon">{{ btn.icon }}</i>
							</button>
						</span>
					</td>
				</tr>
			</template>
		</tbody>
	</table>
</template>

<script>

import TableColumnItem from './TableColumnItem';

const SEARCH_EVENT = 'on-search-event';
const DELETE_ROWS_EVENT = 'on-delete-selected';
const DELETE_ROW_EVENT = 'on-delete-event';
const EXPORT_ROWS_EVENT = 'on-export-selected';
const GO_TO_PHOTOS_EVENT = 'go-to-photos-page';
const GO_TO_EDIT_EVENT = 'go-to-edit-page';
const CHANGE_STATE_EVENT = 'on-change-state';
const ON_SORTABLE_EVENT = 'on-sortable-event';
const OPEN_DETAIL_EVENT = 'on-open-detail';
const ON_DRAG_EVENT = 'on-drag-event';
const ON_DRAG_ENTER = 'on-drag-enter';
const ON_DRAG_LEAVE = 'on-drag-leave';
const ON_DROP_EVENT = 'on-drop-event';
const PREFIX_TABLE_LS = 'tablerun::';

const components = {
	TableColumnItem,
};

function bodyRows() {
	const newRows = this.rows.map((row) => {
		const newRow = row;
		newRow.isSelected = this.checkAll;
		return newRow;
	});
	return newRows;
}

function data() {
	return {
		checkAll: false,
		colspan: null,
		open: false,
		search: '',
	};
}

function disabledAllRows() {
	return this.bodyRows.every(row => !row[this.disabledProp]);
}

function mounted() {
	if (this.localStorage) {
		const searchFromLocalStorage = window.localStorage.getItem(`${PREFIX_TABLE_LS}search`);
		if (searchFromLocalStorage) {
			this.search = searchFromLocalStorage;
			this.$emit(SEARCH_EVENT, searchFromLocalStorage);
		}
	}

	if (this.includeDelete && this.includeExportToExcel) {
		this.colspan = 3;
	} else if (this.includeDelete || this.includeExportToExcel) {
		this.colspan = 2;
	} else {
		this.colspan = null;
	}
}

function columnSortable(column) {
	this.$emit(ON_SORTABLE_EVENT, column);
}

function onChangeState(row) {
	this.$emit(CHANGE_STATE_EVENT, row);
}

function onDeleteRows() {
	const rowsSelected = this.bodyRows.filter(row => row.isSelected);
	if (rowsSelected.length > 0) {
		if (confirm('Are you sure?')) {
			this.$emit(DELETE_ROWS_EVENT, rowsSelected);
		}
	} else {
		alert('You must select one row at least');
	}
}

function openDetail() {
	this.$emit(OPEN_DETAIL_EVENT);
}

function onExportRows() {
	const rowsSelected = this.bodyRows.filter(row => row.isSelected);
	if (rowsSelected.length > 0) {
		if (confirm('Are you sure?')) {
			this.$emit(EXPORT_ROWS_EVENT, rowsSelected);
		}
	} else {
		alert('You must select one row at least');
	}
}

function deleteRow(row) {
	if (confirm('Are you sure?')) {
		this.$emit(DELETE_ROW_EVENT, row);
	}
}

function goToEditPage(row, event) {
	this.$emit(GO_TO_EDIT_EVENT, row, event);
}

function goToPhotosPage(row) {
	this.$emit(GO_TO_PHOTOS_EVENT, row);
}

function searchRows($event) {
	const keyCode = $event.keyCode;
	if (keyCode === 27) {
		this.search = '';
	}
	window.localStorage.setItem(`${PREFIX_TABLE_LS}search`, this.search);
	this.$emit(SEARCH_EVENT, this.search);
}

function onDragEnter(row) {
	this.$emit(ON_DRAG_ENTER, row);
}

function onDragLeave(row) {
	this.$emit(ON_DRAG_LEAVE, row);
}

function onDrop(row) {
	this.$emit(ON_DROP_EVENT, row);
}

function onDrag(row) {
	this.$emit(ON_DRAG_EVENT, row);
}

export default {
	components,
	computed: {
		bodyRows,
		disabledAllRows,
	},
	name: 'table-run',
	data,
	methods: {
		columnSortable,
		deleteRow,
		goToPhotosPage,
		goToEditPage,
		onChangeState,
		onDeleteRows,
		onDrag,
		onDragEnter,
		onDragLeave,
		onDrop,
		onExportRows,
		openDetail,
		searchRows,
	},
	mounted,
	props: {
		columns: {
			type: Array,
			required: true,
		},
		includeDelete: {
			type: Boolean,
			default: true,
		},
		includeExportToExcel: {
			type: Boolean,
			default: true,
		},
		includeSearch: {
			type: Boolean,
			default: true,
		},
		includeOptions: {
			type: Boolean,
			default: false,
		},
		includeState: {
			type: Boolean,
			default: false,
		},
		includeImages: {
			type: Boolean,
			default: false,
		},
		includeSwitch: {
			type: Boolean,
			default: false,
		},
		includeInfo: {
			type: Boolean,
			default: false,
		},
		includeSettings: {
			type: Boolean,
			default: false,
		},
		includeDeleteSingle: {
			type: Boolean,
			default: false,
		},
		localStorage: {
			type: Boolean,
			default: false,
		},
		onDeleteSelected: {
			type: Function,
		},
		onSortableEvent: {
			type: Function,
		},
		rows: {
			type: Array,
			required: true,
		},
		selectable: {
			type: Boolean,
			default: true,
		},
		selectAll: {
			type: Boolean,
			default: false,
		},
		statePropertyName: {
			type: String,
			default: 'state_id',
		},
		switchValue: {
			type: String,
			default: 'flagactive',
		},
		keyValue: {
			type: String,
			default: 'id',
		},
		disabledProp: {
			default: 'flagUse',
			type: String,
		},
		optionButtons: {
			default: () => [],
			type: Array,
		},
	},
};

</script>

<style lang="scss" scoped>
@import './../stylesheets/variables.scss';

input {
	background-color: transparent;
	border-style: none;
}

table.table-list {
	width: 100%;

	thead {
		background-color: map-get($colors, slate);
		color: map-get($colors, white);

		th {
			align-items: center;
			font-family: map-get($fonts, regular);
			font-weight: normal;
			height: map-get($heights, headerTable);

			&:first-child {
				padding-left: 16px;
				width: 40px;
			}

			&:last-child {
				padding-right: 9.5px;
				width: 211px;
			}
			.icon {
				font-size: 20px;
				vertical-align: middle;
			}

			.icon-delete,
			.icon-export {
				color: map-get($colors, white);
			}

			.check-list {
				margin-top: -1px !important;
			}
		}
	}


	tbody {
		tr {
			background-color: map-get($colors, white);
			color: map-get($colors, tableText);
			font-family: map-get($fonts, regular);

			&:nth-child(even) {
				background: map-get($colors, even);
			}

			td {
				align-items: center;
				border-bottom: 1px solid transparent;
				border-top: 1px solid transparent;
				height: map-get($heights, large);
				padding: 0px;

				&:first-child {
					border-left: 1px solid transparent;
					padding-left: 16px;
					width: 40px;
				}

				&:last-child {
					border-right: 1px solid transparent;
					padding-right: 16px;
				}

				.icon {
					color: map-get($colors, tableIcon);
					font-size: 20px;
					height: 30px;
					vertical-align: middle;

					&.image-icon {
						font-size: 21px;
						margin-left: 32px;
					}
				}

				.check-list {
					margin-top: -1px !important;
				}
			}

			&:hover {
				td:not(.td-employee) {
					border-bottom: 1px solid map-get($colors, checked);
					border-top: 1px solid map-get($colors, checked);
					color: map-get($colors, slate);
					font-family: map-get($fonts, medium);

					&:first-child {
						border-left: 1px solid map-get($colors, checked);
					}

					&:last-child {
						border-right: 1px solid map-get($colors, checked);
					}
				}
			}
		}

		tr.is-select {
			td:not(.td-employee) {
				border-bottom: 1px solid map-get($colors, checked);
				border-top: 1px solid map-get($colors, checked);
				color: map-get($colors, slate);
				font-family: map-get($fonts, medium);

				&:first-child {
					border-left: 1px solid map-get($colors, checked);
				}

				&:last-child {
					border-right: 1px solid map-get($colors, checked);
				}
			}

			&-employee {
				td.td-employee {
					border-bottom: 1px solid map-get($colors, checked);
					border-top: 1px solid map-get($colors, checked);
					color: map-get($colors, slate);
					font-family: map-get($fonts, medium);

					&:first-child {
						border-left: 1px solid map-get($colors, checked);
					}

					&:last-child {
						border-right: 1px solid map-get($colors, checked);
					}
				}
			}
		}
	}

	.search-input {
		background-color: map-get($colors, dark);
		border-radius: 6px;
		display: inline-flex;
		height: 32px;
		max-width: 185.5px;
		padding: 0px 0px 0px 19px;

		input {
			color: map-get($colors, white);
			font-size: map-get($sizes, regular);
			outline: none;
			padding: 0 10px 0 0px;
			width: calc(100% - 35px);

			&::-webkit-input-placeholder {
				color: map-get($colors, white);
			}

			&::-moz-placeholder {
				color: map-get($colors, white);
			}

			&:-ms-input-placeholder {
				color: map-get($colors, white);
			}
		}

		.icon {
			font-size: map-get($sizes, searchIcon);
			align-self: center;
		}
	}

	.checkbox {
		.icon {
			font-size: map-get($sizes, checkboxTable);
		}

		.input-group--selection-controls__ripple {
			height: 15px;
			left: 13px;
			width: 15px;
		}
	}

	.options-column {
		text-align: right;

		.options-item {
			display: inline-block;
			height: 17px;
			margin-left: 15px;
			vertical-align: middle;
		}

		.circle-state {
			border-radius: 100%;
			display: inline-block;
			height: 14px;
			width: 14px;

			&.state-3 {
				background-color: map-get($colors, threeState);
			}

			&.state-2 {
				background-color: map-get($colors, twoState);
			}

			&.state-1 {
				background-color: map-get($colors, oneState);
			}
		}

		.switch {
			display: inline-block;
			height: 16.7px;
			margin-bottom: 0 !important;
			position: relative;
			vertical-align: middle;
			width: auto;

			input {
				display: none;
			}

			&-title {
				font-weight: normal;
				margin: 3px 80px;
			}
		}

		.slider {
			background-color: #c1272d;
			cursor: pointer;
			height: 100%;
			transition: .4s;
			width: 26.3px;

			&:before {
				content: '';
				background-color: #fff;
				bottom: 3px;
				height: 11px;
				left: 4px;
				position: absolute;
				transition: .4s;
				width: 11px;
			}

			&.round {
				border-radius: 34px;

				&:before {
					border-radius: 50%;
				}
			}
		}

		input {

			&:checked+.slider {
				background-color: #00b76f;

				&:before {
					transform: translateX(8px);
				}
			}

			&:focus+.slider {
				box-shadow: 0 0 1px #00b76f;
			}
		}

		.button-info,
		.button-info:focus {
			background-color: transparent;
			border: 0px;
			cursor: pointer;
			display: inline-flex;
			outline: none;
			padding: 0px;

			.info-icon {
				height: 20px;
			}
		}

		.settings-icon {
			height: 20px;
		}
	}

	.link-to {
		cursor: pointer;
	}
}
</style>



// WEBPACK FOOTER //
// TableRun.vue?245cf2aa